<template>
  <div class="dashboard_card">
    <div v-for="(item, key) in balanceData" :class="(key + 1) % 3 === 0
      ? 'dashboard_card_item'
      : 'dashboard_card_item dashboard_card_item_mar'
      " :key="key" :style="{
        background: 'linear-gradient(to bottom, #FFFFFF,' + item.color + ')'
      }">
      <div class="dashboard_card_item_top">
        <div class="dashboard_card_item_top_btn" v-if="item.btn" @click="$emit('onWithdraw', item)">
          {{ item.btn }}
        </div>
        <div class="dashboard_card_item_top_title">
          <img :src="item.iconUrl" />
          <div class="title_warp">{{ item.name }}</div>
        </div>
        <div :class="['dashboard_card_item_but', { 'single_item': hasOnlyOneTitle(item) }]">
          <div class="dashboard_card_item_but_item" v-if="item.rightTitle">
            <span class="dashboard_card_item_but_title">{{
              item.rightTitle
            }}</span>
            <span class="dashboard_card_item_but_value _j">
              {{ round(item.cumulativeAmount) }}
            </span>
          </div>

          <div class="dashboard_card_item_but_item" v-if="item.leftTitle">
            <span class="dashboard_card_item_but_title">{{
              item.leftTitle
            }}</span>
            <span class="dashboard_card_item_but_value _j">
              {{ round(item.todayAmount) }}
            </span>
          </div>
          <div class="dashboard_card_item_but_item" v-if="item.balanceTitle">
            <span class="dashboard_card_item_but_title">{{
              item.balanceTitle
            }}</span>
            <span class="dashboard_card_item_but_value _j">
              {{ round(item.balance) }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "dashboardCard",
  props: {
    balanceData: {
      type: Array,
      default: () => {
        return []
      }
    },
    isAgentLogin: {
      type: Number,
      default: 1
    }
  },
  methods: {
    round(val) {
      return Math.round(Number(val) * 100) / 100;
    },
    hasOnlyOneTitle(item) {
      return [item.rightTitle, item.leftTitle, item.balanceTitle].filter(Boolean).length === 1;
    }
  }
};
</script>
<style lang="scss" scoped>
.dashboard_card {
  display: flex;
  flex-wrap: wrap;

  .dashboard_card_item_mar {
    margin-right: 2%;
  }

  .dashboard_card_item {
    width: 32%;
    background: #ffffff;
    box-shadow: 0px 3px 16px 0px rgba(204, 204, 204, 0.3);
    border-radius: 12px;
    height: 160px;
    margin-bottom: 12px;

    .dashboard_card_item_top {
      padding: 20px 15px;
      border-radius: 12px 12px 0px 0px;
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      height: 120px;
      position: relative;

      .dashboard_card_item_top_btn {
        position: absolute;
        top: 10px;
        right: 10px;
        cursor: pointer;
        font-size: 14px;
        color: #fff;
        padding: 5px 12px;
        border-radius: 5px;
        background-color: #1890ff;
      }

      .dashboard_card_item_top_title {
        display: flex;
        align-items: center;
      }

      .title_warp {
        font-size: 24px;
        color: #333333;
        margin-left: 10px;
      }

      .dashboard_card_item_top_value {
        font-weight: bold;
        font-size: 50px;
        color: #000000;
        margin-top: 20px;
      }

      .right_ {
        display: grid;

        .right_title {
          font-weight: 300;
          font-size: 16px;
          color: #333333;
        }

        .right_value {
          font-weight: bold;
          font-size: 30px;
          color: #000000;
        }

        .right_margin {
          margin-top: 5px;
        }
      }
    }

    .dashboard_card_item_but {
      padding: 20px 0px 10px;
      display: flex;
      justify-content: space-around;

      &.single_item {
        justify-content: start;
      }

      .dashboard_card_item_but_item {
        display: flex;
        align-items: center;
      }

      .dashboard_card_item_but_item_fg {
        border-right: 1px solid #eeeeee;
        height: 30px;
        width: 1px;
        margin-right: 20px;
      }

      .dashboard_card_item_but_title {
        font-size: 17px;
        color: #999999;
      }

      .dashboard_card_item_but_value {
        font-weight: 500;
        font-size: 20px;
        margin-left: 5px;
      }

      ._j {
        color: #fe4747;
      }

      ._jj {
        color: #53bc5b;
      }
    }
  }
}

// 平板设备 (768px - 1024px)
@media screen and (max-width: 1024px) and (min-width: 768px) {
  .dashboard_card {
    .dashboard_card_item {
      width: 48%; // 每行2个卡片
      margin-bottom: 15px;

      .dashboard_card_item_top {
        .title_warp {
          font-size: 20px;
        }
      }

      .dashboard_card_item_but {
        .dashboard_card_item_but_title {
          font-size: 15px;
        }

        .dashboard_card_item_but_value {
          font-size: 18px;
        }
      }
    }

    .dashboard_card_item_mar {
      margin-right: 4%;

      &:nth-child(2n) {
        margin-right: 0; // 每行最后一个卡片去掉右边距
      }
    }
  }
}

// 移动设备 (小于768px)
@media screen and (max-width: 767px) {
  .dashboard_card {
    .dashboard_card_item {
      width: 100%; // 每行1个卡片
      margin-bottom: 15px;
      height: 140px; // 稍微减小高度

      .dashboard_card_item_top {
        padding: 15px 12px;
        height: 110px;

        .dashboard_card_item_top_btn {
          font-size: 12px;
          padding: 4px 10px;
          top: 8px;
          right: 8px;
        }

        .dashboard_card_item_top_title {
          img {
            width: 24px; // 减小图标大小
            height: 24px;
          }

          .title_warp {
            font-size: 18px; // 减小标题字体
            margin-left: 8px;
          }
        }
      }

      .dashboard_card_item_but {
        padding: 15px 0px 8px;

        .dashboard_card_item_but_item {
          flex-direction: column; // 改为垂直布局
          align-items: flex-start;

          .dashboard_card_item_but_title {
            font-size: 14px; // 减小字体
            margin-bottom: 4px;
          }

          .dashboard_card_item_but_value {
            font-size: 16px; // 减小数值字体
            margin-left: 0;
            font-weight: 600;
          }
        }
      }
    }

    .dashboard_card_item_mar {
      margin-right: 0; // 移动端不需要右边距
    }
  }
}

// 小屏手机 (小于375px)
@media screen and (max-width: 374px) {
  .dashboard_card {
    .dashboard_card_item {
      height: 130px;

      .dashboard_card_item_top {
        padding: 12px 10px;
        height: 100%; // 改为100%填满整个卡片
        box-sizing: border-box; // 确保padding包含在高度内

        .dashboard_card_item_top_title {
          .title_warp {
            font-size: 16px;
          }
        }
      }

      .dashboard_card_item_but {
        padding: 12px 0px 6px;

        .dashboard_card_item_but_item {
          .dashboard_card_item_but_title {
            font-size: 13px;
          }

          .dashboard_card_item_but_value {
            font-size: 15px;
          }
        }
      }
    }
  }
}
</style>
